import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CommonStore, CaseManagementStore } from "Store";

export default observer(
  class FilterDistribution extends Component {
    state = {
      isLabelOn: true
    };

    render() {
      const { isLabelOn } = this.state;
      return (
        <Wrapper>
          <Button onClick={e => this.onLabelSelected(e)}>
            <Span>{isLabelOn ? "LABELED" : "RESET"}</Span>
          </Button>
        </Wrapper>
      );
    }

    onLabelSelected = () => {
      const { isLabelOn } = this.state;

      this.setState(prevState => ({
        isLabelOn: !prevState.isLabelOn
      }));

      if (isLabelOn === true) {
        const labelAgent = CommonStore.me.agent.labels;
        const arrLabelAgent = [];
        const len = labelAgent.length;
        for (let i = 0; i < len; i++) {
          arrLabelAgent.push({
            value: {
              id: labelAgent[i].labelTemplate.id
            }
          });
        }
        CaseManagementStore.filterLabels = arrLabelAgent;
      } else {
        CaseManagementStore.filterLabels = [];
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex: none;
`;

const Button = styled.div`
  width: 85px;
  background: #f9802e;
  padding: 8px 15px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

const Span = styled.span`
  color: #ffffff;
  font-weight: 600;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/list-panel/filter/FilterDistribution.js